import { Employee } from "@/v2/types";
import ArFormCombobox from "../form/ComboBoxFormField";
import { FieldValues, Path } from "react-hook-form";
import FindAllArOfficeStaff from "@/v2/api/employee/FindAllArOfficeStaff";

export function ArEmployeeComboBox<T extends FieldValues>({
    name,
    storeFullObject = false,
    setSelectedEmployee,
    label = "Select AR Coordinator",
    placeholder = "Select co ordinator...",
    defaultValue,
}: {
    name: Path<T>;
    label?: string;
    placeholder?: string;
    storeFullObject?: boolean;
    setSelectedEmployee?: (value: Employee | null) => void;
    defaultValue: Employee | null;
}) {
    return (
        <ArFormCombobox<T, Employee>
            defaultValue={defaultValue}
            name={name}
            label={label}
            queryKey="ar-employees"
            queryFn={async ({ pageParam, search, limit, filter }) =>
                FindAllArOfficeStaff({
                    skip: pageParam,
                    limit,
                    search,
                    filter,
                })
            }
            additionalFilters={{ is_ar_employee: { eq: [true] } }}
            getDisplayValue={(employee) => employee.full_name}
            renderItem={(employee) => (
                <div className="flex flex-col">
                    <span>{employee.full_name}</span>
                </div>
            )}
            placeholder={placeholder}
            width="w-full"
            storeFullObject={storeFullObject}
            onItemSelect={(employee: Employee | null) => {
                setSelectedEmployee && setSelectedEmployee(employee);
            }}
        />
    );
}
